import './payloadTable.css';

interface PayloadTableProps {
  data: unknown;
}

const renderValue = (value: unknown): React.ReactNode => {
  if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
    return (
      <table className="payload-table" style={{ margin: 0 }}>
        <tbody>
          {Object.entries(value as Record<string, unknown>).map(([k, v]) => (
            <tr key={k}>
              <td className="payload-table__key">{k}</td>
              <td className="payload-table__value">{renderValue(v)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
  if (Array.isArray(value)) {
    return value.map((item, idx) => <div key={idx}>{renderValue(item)}</div>);
  }
  return String(value);
};

export const PayloadTable: React.FC<PayloadTableProps> = ({ data }) => {
  let parsed: Record<string, unknown> = {};

  if (typeof FormData !== 'undefined' && data instanceof FormData) {
    data.forEach((value, key) => {
      parsed[key] = value;
    });
  } else if (typeof data === 'string') {
    try {
      parsed = JSON.parse(data);
    } catch {
      return (
        <div
          className="payload-table__value"
          style={{ whiteSpace: 'pre-wrap' }}
        >
          {data}
        </div>
      );
    }
  } else if (typeof data === 'object' && data !== null) {
    parsed = data as Record<string, unknown>;
  } else {
    return null;
  }

  return (
    <table className="payload-table">
      <tbody>
        {Object.entries(parsed).map(([key, value]) => (
          <tr key={key}>
            <td className="payload-table__key">{key}</td>
            <td className="payload-table__value">{renderValue(value)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
